import { getWalletSummary, isPlainObject } from '../format';
import { useTranslation } from 'react-i18next';
import '../Account.css';

type WalletSummaryProps = {
    wallet: unknown;
};

function WalletSummary({ wallet }: WalletSummaryProps) {
    const { t } = useTranslation('account');
    if (!isPlainObject(wallet)) {
        return null;
    }

    const { currency, rows, updated } = getWalletSummary(wallet);

    if (!rows.length && updated === '—') {
        return null;
    }

    return (
        <section className="panel account-wallet" aria-label={t('sections.wallet')}>
            <div className="section-head">
                <h2>{t('sections.wallet')}</h2>
                <span className="account-wallet__badge">{currency}</span>
            </div>

            {rows.length ? (
                <div className="account-wallet__stats">
                    {rows.map((row) => (
                        <div key={row.key} className="account-wallet__stat">
                            <small>{row.label}</small>
                            <strong>
                                {row.amount} <span>{currency}</span>
                            </strong>
                        </div>
                    ))}
                </div>
            ) : null}

            {updated !== '—' ? (
                <p className="account-wallet__updated mt-2">
                    {t('wallet.updated', { value: updated })}
                </p>
            ) : null}
        </section>
    );
}

export default WalletSummary;
